module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABfSURBVDhPYxj0wBiIlSBM0oEJED8E4vNArAgSIAWAbF4JxEVA7A/EG4GYaENgmjmBOBOIbYBYGIiJNiQdiEGaQQBmAAiADImDMIkHyAaQBUYNoIIBokDMC2EOTsDAAADCZwy/rjYVgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/UpArrow.png
// module id = 669
// module chunks = 0